import { signal } from "@preact-signals/safe-react";
export const selectedUnitMeta$ = signal(undefined);
//# sourceMappingURL=unitMeta.js.map